const dialCodes = {
  ad: '00376',
  ae: '00971',
  af: '0093',
  ag: '001-268',
  ai: '001-264',
  al: '00355',
  am: '00374',
  ao: '00244',
  aq: '00672',
  ar: '0054',
  as: '001-684',
  at: '0043',
  au: '0061',
  aw: '00297',
  ax: '00358',
  az: '00994',
  ba: '00387',
  bb: '001-246',
  bd: '00880',
  be: '0032',
  bf: '00226',
  bg: '00359',
  bh: '00973',
  bi: '00257',
  bj: '00229',
  bl: '00590',
  bm: '001-441',
  bn: '00673',
  bo: '00591',
  bq: '00599',
  br: '0055',
  bs: '001-242',
  bt: '00975',
  bv: '0047',
  bw: '00267',
  by: '00375',
  bz: '00501',
  ca: '001',
  cc: '0061',
  cd: '00243',
  cf: '00236',
  cg: '00242',
  ch: '0041',
  ci: '00225',
  ck: '00682',
  cl: '0056',
  cm: '00237',
  cn: '0086',
  co: '0057',
  cr: '00506',
  cu: '0053',
  cv: '00238',
  cw: '00599',
  cx: '0061',
  cy: '00357',
  cz: '00420',
  de: '0049',
  dj: '00253',
  dk: '0045',
  dm: '001-767',
  do: '001-809,1-829,1-849',
  dz: '00213',
  ec: '00593',
  ee: '00372',
  eg: '0020',
  eh: '00212',
  er: '00291',
  es: '0034',
  et: '00251',
  fi: '00358',
  fj: '00679',
  fk: '00500',
  fm: '00691',
  fo: '00298',
  fr: '0033',
  ga: '00241',
  gb: '0044',
  gd: '001-473',
  ge: '00995',
  gf: '00594',
  gg: '0044',
  gh: '00233',
  gi: '00350',
  gl: '00299',
  gm: '00220',
  gn: '00224',
  gp: '00590',
  gq: '00240',
  gr: '0030',
  gs: '00500',
  gt: '00502',
  gu: '001-671',
  gw: '00245',
  gy: '00592',
  hk: '00852',
  hm: '00672',
  hn: '00504',
  hr: '00385',
  ht: '00509',
  hu: '0036',
  id: '0062',
  ie: '00353',
  il: '00972',
  im: '0044',
  in: '0091',
  io: '00246',
  iq: '00964',
  ir: '0098',
  is: '00354',
  it: '0039',
  je: '0044',
  jm: '001-876',
  jo: '00962',
  jp: '0081',
  ke: '00254',
  kg: '00996',
  kh: '00855',
  ki: '00686',
  km: '00269',
  kn: '001-869',
  kp: '00850',
  kr: '0082',
  kw: '00965',
  ky: '001-345',
  kz: '007',
  la: '00856',
  lb: '00961',
  lc: '001-758',
  li: '00423',
  lk: '0094',
  lr: '00231',
  ls: '00266',
  lt: '00370',
  lu: '00352',
  lv: '00371',
  ly: '00218',
  ma: '00212',
  mc: '00377',
  md: '00373',
  me: '00382',
  mf: '00590',
  mg: '00261',
  mh: '00692',
  mk: '00389',
  ml: '00223',
  mm: '0095',
  mn: '00976',
  mo: '00853',
  mp: '001-670',
  mq: '00596',
  mr: '00222',
  ms: '001-664',
  mt: '00356',
  mu: '00230',
  mv: '00960',
  mw: '00265',
  mx: '0052',
  my: '0060',
  mz: '00258',
  na: '00264',
  nc: '00687',
  ne: '00227',
  nf: '00672',
  ng: '00234',
  ni: '00505',
  nl: '0031',
  no: '0047',
  np: '00977',
  nr: '00674',
  nu: '00683',
  nz: '0064',
  om: '00968',
  pa: '00507',
  pe: '0051',
  pf: '00689',
  pg: '00675',
  ph: '0063',
  pk: '0092',
  pl: '0048',
  pm: '00508',
  pn: '00870',
  pr: '001',
  ps: '00970',
  pt: '00351',
  pw: '00680',
  py: '00595',
  qa: '00974',
  re: '00262',
  ro: '0040',
  rs: '00381 p',
  ru: '007',
  rw: '00250',
  sa: '00966',
  sb: '00677',
  sc: '00248',
  sd: '00249',
  se: '0046',
  sg: '0065',
  sh: '00290 n',
  si: '00386',
  sj: '0047',
  sk: '00421',
  sl: '00232',
  sm: '00378',
  sn: '00221',
  so: '00252',
  sr: '00597',
  ss: '00211',
  st: '00239',
  sv: '00503',
  sx: '001-721',
  sy: '00963',
  sz: '00268',
  tc: '001-649',
  td: '00235',
  tf: '00262',
  tg: '00228',
  th: '0066',
  tj: '00992',
  tk: '00690',
  tl: '00670',
  tm: '00993',
  tn: '00216',
  to: '00676',
  tr: '0090',
  tt: '001-868',
  tv: '00688',
  tw: '00886',
  tz: '00255',
  ua: '00380',
  ug: '00256',
  us: '001',
  uy: '00598',
  uz: '00998',
  va: '0039-06',
  vc: '001-784',
  ve: '0058',
  vg: '001-284',
  vi: '001-340',
  vn: '0084',
  vu: '00678',
  wf: '00681',
  ws: '00685',
  ye: '00967',
  yt: '00262',
  za: '0027',
  zm: '00260',
  zw: '00263',
};

export default dialCodes;
